import i18n from 'i18next';



export function capitalizeWord(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}



export const copyToClipBoard = async (copyMe: string) => {
    try {
        await navigator.clipboard.writeText(copyMe);
        return true;
    } catch (err) {
        return false
    }
};


export const isRTL = () => {
    const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];
    const currentLanguage = i18n.language; // get current language from i18n
    return RTL_LANGUAGES.includes(currentLanguage);
};
